import {ModuleType} from "./types"
import {generateUniqueId} from "../gd/utils/misc/generate-unique-id"
import SettingsModule from "./settings-module"
// import {License} from "../gd/const/license"

// const debug = "ModuleProto"
const debug = false

export class ModuleProto extends SettingsModule {

    public type                     : ModuleType
    public canDisable               : boolean       = true  // if true user can turn / off this module

    public typeLabel                : string        = 'NOT SET'
    public instanceId               : string        // a chto eto ? ne pomnu navernoe nuzno

    // public allowedForLicenses?      : License[]

    constructor(moduleType: ModuleType, moduleConfig:any) {

        super(moduleConfig)

        this.type           = moduleType
        this._isEnabled     = _.get(moduleConfig,'isEnabled', true)

        this.instanceId     = generateUniqueId()

        // this.requiredLicense    = LicenseType.Business
    }

    /*get enabled() {
        return this._isEnabled
    }*/

    /*validateLicense() {
        if (this.allowedForLicenses) {
            if (!this.allowedForLicenses.includes(gd.company.license.license)) {
                this._isEnabled = false
            }
        }
    }*/

    // do not make it ()=>{} it will make it an instance method but we need inheritance (!)
    enable() {
        debug && console.log(debug, "enable() instanceId=", this.instanceId, "before update isEnabled=", this._isEnabled)
        debug && console.log("    this.type=", this.type)

        // !!! MEGA HACK - raznie instances... esli chto ask Vic
        // this._isEnabled = true

        // @ts-ignore
        gd.modules[this.type]._isEnabled = true

        gd.modules.saveConfig()
    }

    disable():void {
        debug && console.log(debug, "disable() type=",this.type," instanceId=", this.instanceId, "before update isEnabled=", this._isEnabled)
        // !!! MEGA HACK - raznie instances... esli chto ask Vic

        this._isEnabled = false

        // @ts-ignore
        gd.modules[this.type]._isEnabled = false

        gd.modules.saveConfig()
    }

    toJson():JSONObject {
        return {
            isEnabled       : this._isEnabled
        }
    }

    saveSettings() {
        gd.modules.saveConfig()
    }
}
